import { config } from '~app/config';

import { makeRequest } from '~shared/api/make-request';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { skipToken, useQuery } from '@tanstack/react-query';

import { confirmationKeys } from './confirmation-keys';

import type { GetMerchantOrderResponse } from '../model';

type UseGetMerchantOrderParams = {
  applicationId: string | undefined;
};

export const useGetMerchantOrder = ({
  params,
  enabled = true,
}: {
  params: UseGetMerchantOrderParams;
  enabled?: boolean;
}) => {
  const { applicationId } = params;

  return useQuery({
    queryKey: confirmationKeys.order(
      applicationId,
      'MERCHANT_PARTNER_AGREEMENT'
    ),
    queryFn: applicationId
      ? () =>
          makeRequest<ResponseSuccess<GetMerchantOrderResponse>>({
            url: `${config.apiHost}/confirmation/merchant_portal/api/v1/merchant/get_order`,
            credentials: 'include',
            payload: {
              ...params,
              type: 'MERCHANT_PARTNER_AGREEMENT',
            },
          }).then((response) => response.payload)
      : skipToken,
    enabled,
  });
};
